import React, { useState } from "react";
import styles from "../login/Login.module.scss";
import Input from "../../../components/common/input/Input";
import { useAuth } from "../../../context/AuthContext";
import AuthService from "../../../api/services/auth.service";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import BannerImage from "../../../assets/images/login/BannerImage.png";
import Button from "../../../components/common/button/Button";
import { useLocalizedNavigate } from "../../../hooks/useLocalizedNavigate";
import { useTranslation } from "react-i18next";

const ConfirmPassword = () => {
  const { t } = useTranslation("translation");
  const { email } = useAuth();
  const [passwordValue, setPasswordValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessages, setErrorMessages] = useState<{
    code?: string;
    password?: string;
  }>({});
  const [loading, setLoading] = useState(false);

  const navigate = useLocalizedNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errors: typeof errorMessages = {};
    if (!codeValue) errors.code = t("errors.verificationCodeRequired") || "";
    if (!passwordValue) errors.password = t("errors.passwordRequired") || "";

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("code", codeValue);
      formData.append("new_password", passwordValue);

      await AuthService.confirmForgetPassword(formData);
      navigate("/auth/login");
    } catch (error: any) {
      setLoading(false);
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("common_error");
      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.login}>
      <TitleUpdater title={t("confrim_password")} />
      <div className="container">
        <div className={styles.content}>
          <div className={styles.img}>
            <img src={BannerImage} alt="" />
          </div>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.head}>
              <h1 className={styles.title}>{t("confrim_title")}</h1>
              <p className={styles.description}>{t("forget_title")}</p>
              {errorMessage && (
                <p className={styles.errorMessage}>{errorMessage}</p>
              )}
            </div>
            <div className={styles.inputs}>
              <Input
                label={t("verification_code") || ""}
                placeholder={t("placeholders.verification_code") || ""}
                type="text"
                id="code"
                value={codeValue}
                onChange={(e) => {
                  setCodeValue(e.target.value);
                  setErrorMessage("");
                  setErrorMessages((prev) => ({ ...prev, code: "" }));
                }}
                error={errorMessages.code}
              />
              <Input
                type="password"
                id="password"
                label={t("password") || ""}
                placeholder="••••••••••"
                value={passwordValue}
                onChange={(e) => {
                  setPasswordValue(e.target.value);
                  setErrorMessage("");
                  setErrorMessages((prev) => ({ ...prev, password: "" }));
                }}
                error={errorMessages.password}
              />
            </div>
            <div className={styles.login_btn}>
              <Button loading={loading} disabled={loading} type="submit">
                {t("submit")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPassword;
